import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ExercisesService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdExercises(exerciseId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'Exercises/deleteExercises', {'exerciseId': exerciseId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countExercises(exercises): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'Exercises/count', {'exercises': exercises}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updateExercises(exercises): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Exercises/updateExercises', [exercises], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addExercises(exercises): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Exercises/addExercises', [exercises], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllExercises(exercises, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Exercises/findAllExercises',
            {'exercises': exercises, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
